export default __webpack_public_path__ + "static/media/xprize-website.5512cbac.png";